import {
  ChakraProvider,
  ColorModeProvider,
  ToastProvider,
} from '@chakra-ui/react';
import '@fontsource/inter/index.css';
import { store, useAppDispatch, useAuth } from 'core';
import { LoginForm, LoginProvider } from 'features';
import { TestPage } from 'features/test.page';
import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import App from './App';
import './index.css';
// import reportWebVitals from './reportWebVitals';
import { AppTheme } from './theme';

const container = document.getElementById('root')!;
const root = createRoot(container);

const LoginPage = () => {
  const auth = useAuth();

  if (auth) {
    return <Navigate to="/app/dashboard" />;
  }

  return (
    <React.Suspense fallback={<>...</>}>
      <LoginForm />
    </React.Suspense>
  );
};

BigInt.prototype['toJSON'] = function () {
  return JSON.stringify(this.toString());
};
// BigInt.prototype.toJSON = function () {
//   return JSON.rawJSON(this.toString());
// };
// const AppPage = () => {
//   const auth = useAuth();
//   if (!auth) {
//     return <Navigate to={'/login'} />;
//   }

//   return (
//     <React.Suspense fallback={<>...</>}>
//       <App />
//     </React.Suspense>
//   );
// };

// const LoginForwarder = () => {
//   const auth = useAuth();

//   if (!auth) {
//     return <Navigate to={'/app'} />;
//   } else {
//     return <Navigate to={'/login'} />;
//   }
// };

const LogoutPage = () => {
  const auth = useAuth();
  const dispatch = useAppDispatch();

  if (auth) {
    dispatch(logout({}));
  }

  return <Navigate to="/login" />;
};

root.render(
  <React.StrictMode>
    <Provider store={store}>
      <ChakraProvider
        theme={AppTheme}
        toastOptions={{ defaultOptions: { position: 'bottom' } }}
      >
        <ColorModeProvider
          options={{ initialColorMode: 'dark', useSystemColorMode: true }}
        >
          <LoginProvider>
            <BrowserRouter>
              <Routes>
                <Route path="/logout" element={<LogoutPage />} />
                <Route path="/login" element={<LoginPage />} />
                <Route path="/test" element={<TestPage />} />
                <Route path="/app/*" element={<App />} />
                <Route path="*" element={<Navigate to="/login" />} />
              </Routes>
            </BrowserRouter>
          </LoginProvider>
        </ColorModeProvider>
      </ChakraProvider>
    </Provider>
    {/* <ToastContainer
      position="top-right"
      autoClose={5000}
      hideProgressBar={false}
      newestOnTop={false}
      closeOnClick
      rtl={false}
      pauseOnFocusLoss
      draggable
      pauseOnHover
      theme="dark"
    /> */}
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
function logout(arg0: {}): any {
  throw new Error('Function not implemented.');
}
